module.exports = __webpack_public_path__ + "img/image11.3761ab7a.png";